import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d6e46a1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "export-preview-skeleton col-12",
    type: "filled",
    loading: true
};
const _hoisted_2 = { class: "export-preview-skeleton__table-wrapper" };
const _hoisted_3 = { class: "export-preview-skeleton__table-header" };
const _hoisted_4 = { class: "export-preview-skeleton__table-body" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalExportPreviewSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(SkeletonLoader), {
                            width: "63px",
                            height: "14px",
                            class: "skeleton"
                        }),
                        _createVNode(_unref(SkeletonLoader), {
                            width: "42px",
                            height: "14px",
                            class: "skeleton"
                        }),
                        _createVNode(_unref(SkeletonLoader), {
                            width: "85px",
                            height: "14px",
                            class: "skeleton"
                        }),
                        _createVNode(_unref(SkeletonLoader), {
                            width: "125px",
                            height: "14px",
                            class: "skeleton"
                        }),
                        _createVNode(_unref(SkeletonLoader), {
                            width: "86px",
                            height: "14px",
                            class: "skeleton"
                        }),
                        _createVNode(_unref(SkeletonLoader), {
                            width: "123px",
                            height: "14px",
                            class: "skeleton"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (row) => {
                            return _createElementVNode("div", {
                                key: row,
                                class: "export-preview-skeleton__table-row"
                            }, [
                                _createVNode(_unref(SkeletonLoader), {
                                    width: "95px",
                                    height: "14px",
                                    class: "skeleton"
                                }),
                                _createVNode(_unref(SkeletonLoader), {
                                    width: "68px",
                                    height: "14px",
                                    class: "skeleton"
                                }),
                                _createVNode(_unref(SkeletonLoader), {
                                    width: "40px",
                                    height: "14px",
                                    class: "skeleton"
                                }),
                                _createVNode(_unref(SkeletonLoader), {
                                    width: "20px",
                                    height: "14px",
                                    class: "skeleton"
                                }),
                                _createVNode(_unref(SkeletonLoader), {
                                    width: "62px",
                                    height: "14px",
                                    class: "skeleton"
                                }),
                                _createVNode(_unref(SkeletonLoader), {
                                    width: "95px",
                                    height: "14px",
                                    class: "skeleton"
                                })
                            ]);
                        }), 64))
                    ])
                ])
            ]));
        };
    }
});
